export default {
  playerModel: state => {
    return state.player
      ? `models/players/${state.player}.glb`
      : null
  },
  characterModel: state => {
    return state.character
      ? `models/characters/${state.character}/animated.glb`
      : null
  },
  environmentModel: state => {
    return state.data && state.data.environment
      ? state.data.environment
      : null
  }
}
